// extracted by mini-css-extract-plugin
export default {"root":"Container_root__PQyfK","variant2":"Container_variant2__iGczZ","variant3":"Container_variant3__2OjaW","movein":"Container_movein__nRv9T"};